import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiHeader from "../../components/MuiHeader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import UndoIcon from "@mui/icons-material/Undo";
import Modal from "@mui/material/Modal";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import TextField from "@mui/material/TextField";
import AddIcon from "@mui/icons-material/Add";
import api from "../../api/api";
import { red, blue, green, purple } from "@mui/material/colors";
// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  TableHead,
  TableCell,
  Table,
  TableRow,
  TableBody,
  Paper,
} from "@mui/material";
import Quiz from "../quiz_template/Quiz";
// import {
//   getQuizThunk,
//   createIntroQuizThunk,
//   updateCommonQuizTopicThunk,
//   deleteQuizThunk,
// } from "./IntroQuiz.Thunk";
import { getAmazonPayPasswordThunk } from "./AmazonePayThunk";

const AmazonPay = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [recordId, setRecordId] = useState("");
  const [selectedSkillsetId, setSelectedSkillsetId] = useState("");
  const [selectedSkillsetName, setSelectedSkillsetName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, _id, topicId, topicName, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setRecordId(_id);
    setSelectedSkillsetId(topicId);
    setSelectedSkillsetName(topicName);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
  };
  // ---------------------------------------------

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // ---------------- navigate to skillset manager -------------
  const navigate_to = () => {
    navigate("/commonmonthlyquiz");
  };
  // ------------------------------------------------------------

  // --------- options for dropdowns ---------
  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "school", text: "School" },
    { value: "anganwadi", text: "Anganwadi" },
  ];

  const handleSaveClick = async () => {
    const result = await Swal.fire({
      title: "Enter Password!",
      input: "text",
      inputPlaceholder: "Enter your password.",
      inputAttributes: {
        autocapitalize: "off",
        autocorrect: "off",
      },
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Submit",
      confirmButtonColor: "#3085d6",
      inputValidator: (value) => {
        if (!value) {
          return "Please enter the password!";
        } else if (value !== "tHINKZONEcda-11") {
          return "Password is incorrect!";
        }
      },
    });

    if (result.isConfirmed) {
      try {
        await dispatch(getAmazonPayPasswordThunk());

        Swal.fire("Success!", "Successfully Verified.", "success");
        navigate("/amazoncreatevoucher");
      } catch (error) {
        console.error("Error checking password:", error);
        Swal.fire("Error!", "Failed to update data.", "error");
      }
    }
  };

  return (
    <>
      <div>
        <MuiHeader header="AmazonPay Voucher" />

        <FormControl
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            // border: "5px solid #FFFF00",
            padding: "10px",
          }}
          size="small"
        >
          <Button variant="contained" onClick={handleSaveClick}>
            To add AmazonPay Voucher Click here
          </Button>
        </FormControl>
      </div>
      {/* Toaster */}
      <ToastContainer />
    </>
  );
};

export default AmazonPay;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
